import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface, } from 'src/app/Interface/Calibration_Interface';
import { DataEntity_Detail_03_Interface, Empty_DataEntity_Detail_03_Interface } from 'src/app/Interface/DataEntity/03/DataEntity_Detail_03_Interface';
import { DataEntity_Main_03_Interface, Empty_DataEntity_Main_03_Interface } from 'src/app/Interface/DataEntity/03/DataEntity_Main_03_Interface';
import { DataEntity_Resolution_03_Interface, Empty_DataEntity_Resolution_03_Interface } from 'src/app/Interface/DataEntity/03/DataEntity_Resolution_03_Interface';
import { Device_MPE_Interface } from 'src/app/Interface/Device_MPE_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { DataEntity03Service } from 'src/app/Service/DataEntity/03/DataEntity03.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-DataEntity03',
  templateUrl: './DataEntity03.component.html',
  styleUrls: ['./DataEntity03.component.scss']
})
export class DataEntity03Component implements OnInit {

  constructor(
    private Calibration_Service: CalibrationService,
    private DataEntity03_Service: DataEntity03Service,
    private DataEntityMain_Service: DataEntityMainService,
    private Alerify_Service: AlertifyService,
    private Unit_Service: UnitService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) { }
  FileName: string = '';
  FolderName: string = '';
  Capability: string = '';

  CertificateCode: String = '';
  CertificateUrlPdf: string = ''

  Manufacture_txt: String = '';
  Type_txt: String = '';
  Model_txt: String = '';

  Fororaftegi_txt: String = '';
  working_temp_min_txt: String = '';
  working_temp_max_txt: String = '';


  DataEntity_Id: number = 4;


  InProccessing: boolean = false;
  Calibration_Device_Id: number = 0;
  Calibration_Id: number = 0;
  Observation: number = 0;


  unit_nomimal: string = ''
  unit_reference: string = ''
  unit_correction: string = ''
  unit_correction_eqution: string = ''
  unit_uncertainy: string = ''
  unit_working: string = ''
  unit_zfactor: string = ''


  ngOnInit() {

    this.MainFormDataEntity = new FormGroup({
      id: new FormControl(),

      Temperature_Air_before: new FormControl(null, [Validators.required]),
      Temperature_Air_after: new FormControl(null, [Validators.required]),

      Humidity_Air_before: new FormControl(null, [Validators.required]),
      Humidity_Air_after: new FormControl(null, [Validators.required]),

      Pressure_before: new FormControl(null, [Validators.required]),
      Pressure_after: new FormControl(null, [Validators.required]),
    });

    this.ResolutionFormDataEntity = new FormGroup({
      range_max: new FormControl(null, [Validators.required]),
      range_min: new FormControl(null, [Validators.required]),
      scale: new FormControl(null, [Validators.required]),
    });

    this.Calibration_Device_Id = Number(this.route.snapshot.paramMap.get('id'));
    this.OnIntial();
  }

  OnIntial() {
    this.DataEntity03_Service.GetSingle(this.Calibration_Device_Id, this.DataEntity_Id).subscribe(
      (data) => {
        if (data['result'] != null) {
          var temp: DataEntity_Main_03_Interface = Empty_DataEntity_Main_03_Interface();
          this.Observation = data['observation'];
          this.DataList_Resolution = data['resolution'];
          this.Nominal_Value_List = []

          temp = data['result'];
          this.Calibration_Id = temp.id;
          this.FileName = temp.filename;
          this.FolderName = temp.pdf_src;
          this.Capability = temp.capability;

          this.unit_nomimal = temp.unit_nomimal;
          this.unit_reference = temp.unit_reference;
          this.unit_correction = temp.unit_correction;
          this.unit_correction_eqution = temp.unit_correction_eqution;
          this.unit_uncertainy = temp.unit_uncertainy;
          this.unit_working = temp.unit_working;
          this.unit_zfactor = temp.unit_zfactor;

          this.Fororaftegi_txt = temp.fororaftegi;
          this.working_temp_min_txt = temp.working_temp_min;
          this.working_temp_max_txt = temp.working_temp_max;

          this.Manufacture_txt = temp.manufacture;
          this.Type_txt = temp.type;
          this.Model_txt = temp.model;

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""



          this.get_Form_Temperature_Air_before().setValue(temp['temperature_Air_before']);
          this.get_Form_Temperature_Air_after().setValue(temp['temperature_Air_after']);

          this.get_Form_Humidity_Air_before().setValue(temp['humidity_Air_before']);
          this.get_Form_Humidity_Air_after().setValue(temp['humidity_Air_after']);

          this.get_Form_Pressure_before().setValue(temp['pressure_before']);
          this.get_Form_Pressure_after().setValue(temp['pressure_after']);

          for (let item of data['detail']) {

            var tempDetail: DataEntity_Detail_03_Interface = Empty_DataEntity_Detail_03_Interface();

            tempDetail.reference = item['reference'];
            tempDetail.indication = item['indication'];
            tempDetail.uncertainty = item['uncertainty'];
            tempDetail.converage = item['converage'];
            tempDetail.value = item['value'];


            tempDetail.before = item['before'];


            this.Nominal_Value_List.push(tempDetail);



          }
        }

        //this.MainDataEntity_List = data['result']
        //this.UploadImageSrc_List = data['image']
        //this.canAdd_SubmitDATEOFISSUE_Date = data['canAdd_SubmitDATEOFISSUE_Date']
        //this.SubmitDATEOFISSUE_Date = data['certificate_Code']['date_of_issue']
        this.Read_Unit()
        this.CertificateCode = data['certificate_Code'];
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  //#region Main Data Entity

  Nominal_Value_List: Array<DataEntity_Detail_03_Interface> = [];
  MainFormDataEntity: FormGroup;

  get_Form_Temperature_Air_before() {
    return this.MainFormDataEntity.get('Temperature_Air_before') as FormControl;
  }
  get_Form_Temperature_Air_after() {
    return this.MainFormDataEntity.get('Temperature_Air_after') as FormControl;
  }

  get_Form_Humidity_Air_before() {
    return this.MainFormDataEntity.get('Humidity_Air_before') as FormControl;
  }
  get_Form_Humidity_Air_after() {
    return this.MainFormDataEntity.get('Humidity_Air_after') as FormControl;
  }

  get_Form_Pressure_before() {
    return this.MainFormDataEntity.get('Pressure_before') as FormControl;
  }
  get_Form_Pressure_after() {
    return this.MainFormDataEntity.get('Pressure_after') as FormControl;
  }


  //#endregion

  //#region Upload

  Procssing_Import: boolean = false
  upload_file_excel(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import = true

    this.DataEntity03_Service.uploadFile(formData).subscribe(
      data => {
        this.Procssing_Import = false
        if (data['dsc']) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Nominal_Value_List = []
          this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")

          this.FileName = data['filename']
          this.Capability = data['capability']

          for (let item of data['nominal']) {
            var temp: DataEntity_Detail_03_Interface = Empty_DataEntity_Detail_03_Interface()

            temp.uncertainty = item['uncertainty']
            temp.reference = item['reference']
            temp.indication = item['indication']
            temp.converage = item['converage']
            temp.value = item['value']
            this.Nominal_Value_List.push(temp)

          }

        }
      }
    )

  }

  Procssing_Import2: boolean = false
  upload_file_pdf(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import2 = true

    this.DataEntity03_Service.uploadPdf(formData).subscribe(
      data => {
        this.Procssing_Import2 = false
        if (data['dsc']) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")
          this.FolderName = data['fodlername']

        }
      }
    )

  }

  //#endregion

  //#region Calibration
  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface();
  Set_CalibrationDeviceInfo_click(input: Calibration_Interface) {
    this.Calibration_Device = input
  }

  //#endregion

  //#region Unit
  modalRef_Unit: any
  DataList_Unit: Array<Unit_Interface> = []
  Read_Unit() {
    this.Unit_Service.GetDataEntity(this.DataEntity_Id).subscribe(
      data => {
        this.DataList_Unit = data

      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }



  Selected_Unit: string = ''

  OnUserSetUnit(index: Number, template: TemplateRef<any>) {
    if (!this.unit_nomimal && index != 1)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_reference && index != 2)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_correction && index != 3)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_correction_eqution && index != 4)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_uncertainy && index != 5)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_working && index != 6)
      this.Set_Selected_Unit(index, template)
  }

  Set_Selected_Unit(index: Number, template: TemplateRef<any>) {
    if (index == 1)
      this.Selected_Unit = this.unit_nomimal
    else if (index == 2)
      this.Selected_Unit = this.unit_reference
    else if (index == 3)
      this.Selected_Unit = this.unit_correction
    else if (index == 4)
      this.Selected_Unit = this.unit_correction_eqution
    else if (index == 5)
      this.Selected_Unit = this.unit_uncertainy
    else if (index == 6)
      this.Selected_Unit = this.unit_working

    if (this.Selected_Unit)
      this.modalRef_Unit = this.modalService.show(template);
  }

  SetToAllUnit() {
    if (!this.unit_nomimal)
      this.unit_nomimal = this.Selected_Unit

    if (!this.unit_reference)
      this.unit_reference = this.Selected_Unit

    if (!this.unit_correction)
      this.unit_correction = this.Selected_Unit

    if (!this.unit_correction_eqution)
      this.unit_correction_eqution = this.Selected_Unit

    if (!this.unit_uncertainy)
      this.unit_uncertainy = this.Selected_Unit

    if (!this.unit_working)
      this.unit_working = this.Selected_Unit

    this.modalRef_Unit.hide()
  }


  //#endregion

  //#region Resolution
  ResolutionFormDataEntity: FormGroup;
  DataList_Resolution: Array<DataEntity_Resolution_03_Interface> = []

  Delete_Resolution(id: number) {
    this.DataList_Resolution.splice(id, 1)
    this.Alerify_Service.SuccessMessage("حذف شد")
  }

  Add_Resolution() {

    var CanAdd: Boolean = true
    for (let item of this.DataList_Resolution) {
      if (Number(item.range_min) <= Number(this.get_Form_range_min().value) && Number(this.get_Form_range_min().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
      else if (Number(item.range_min) <= Number(this.get_Form_range_max().value) && Number(this.get_Form_range_max().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
    }

    if (this.DataList_Resolution.length >= 7) {
      this.Alerify_Service.ErrorMessage("حداکثر ۷ مورد رنج و رزلوشن می تواند ثبت کرد!")
    }
    else if (CanAdd) {

      var temp: DataEntity_Resolution_03_Interface = Empty_DataEntity_Resolution_03_Interface()
      temp.range_min = this.get_Form_range_min().value + ''
      temp.range_max = this.get_Form_range_max().value + ''
      temp.scale = this.get_Form_scale().value + ''
      this.DataList_Resolution.push(temp)
      this.Alerify_Service.SuccessMessage("اطلاعات ثبت شد")
    }
    else {
      this.Alerify_Service.ErrorMessage("اطلاعات جدید با اطلاعات موجود همپوشانی دارد")
    }
  }


  get_Form_range_min() {
    return this.ResolutionFormDataEntity.get('range_min') as FormControl;
  }

  get_Form_range_max() {
    return this.ResolutionFormDataEntity.get('range_max') as FormControl;
  }

  get_Form_scale() {
    return this.ResolutionFormDataEntity.get('scale') as FormControl;
  }

  //#endregion

  //#region LabAddress

  Set_LabAddress_click(input: string) {
    this.Calibration_Device.labAdderss = input

  }

  //#endregion

  modalRef_CodeSerial: any;
  modalRef_Code: any;

  onSubmit(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {

    if ((this.Calibration_Device.device_serial.trim() == "" || this.Calibration_Device.device_code.trim() == "") && id == 0) {
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else {
      this.InProccessing = true;
      var temp: DataEntity_Main_03_Interface = Empty_DataEntity_Main_03_Interface();

      temp.id = this.Calibration_Id;

      temp.unit_nomimal = this.unit_nomimal;
      temp.unit_reference = this.unit_reference;
      temp.unit_correction = this.unit_correction;
      temp.unit_correction_eqution = this.unit_correction_eqution;
      temp.unit_uncertainy = this.unit_uncertainy;
      temp.unit_working = this.unit_working;
      temp.unit_zfactor = this.unit_zfactor;


      temp.temperature_Air_before = this.get_Form_Temperature_Air_before().value;
      temp.temperature_Air_after = this.get_Form_Temperature_Air_after().value;

      temp.humidity_Air_before = this.get_Form_Humidity_Air_before().value;
      temp.humidity_Air_after = this.get_Form_Humidity_Air_after().value;

      temp.pressure_before = this.get_Form_Pressure_before().value;
      temp.pressure_after = this.get_Form_Pressure_after().value;

      this.DataEntity03_Service.Submit(
        temp,
        this.Nominal_Value_List,
        this.DataList_Resolution,
        this.DataEntity_Id,
        this.Calibration_Device_Id,
        this.FileName,
        this.FolderName,
        this.Capability,
        this.Calibration_Device.device_serial,
        this.Calibration_Device.device_code,
        this.Manufacture_txt,
        this.Type_txt,
        this.Model_txt,
        this.Calibration_Device.labAdderss,
        0,

        this.Fororaftegi_txt,
        this.working_temp_min_txt,
        this.working_temp_max_txt).subscribe((data) => {
        this.InProccessing = false;
        if (data['id'] == -1) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else if (data['certificate_Code'] == '') {
          this.Alerify_Service.ErrorMessage('خطا سیستمی');
        } else {
          this.CertificateCode = data['certificate_Code'];
          this.Alerify_Service.SuccessMessage('اطلاعات ثبت شد');

          this.OnIntial()

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""

          this.modalRef_Code = this.modalService.show(template);
        }
      });

    }
  }

  onSubmit_Code(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {
    this.onSubmit(template, templateCodeSerial, 1)
    this.modalRef_CodeSerial.hide()
  }


}
